import { IApiRequestConfig } from '../api.types';

export const syncUserWithSlackApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'syncUserWithSlack',
  uri: 'json',
  action: 'slack/sync/all-workspaces',
  method: 'post',
  v2: true,
});
